import React from 'react';

const ErrorModal = ({
    show = false,
    onClose,
    title = 'Error',
    message = '',
    primaryButtonText = 'OK',
    onPrimary,
    secondaryButtonText = null,
    onSecondary = null
}) => {
    if (!show) return null;

    const handlePrimary = () => {
        if (onPrimary) onPrimary();
        else if (onClose) onClose();
    };

    return (
        <>
            <div className="modal fade show d-block" tabIndex="-1" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <h5 className="modal-title text-danger d-flex align-items-center">
                                <i className="fas fa-exclamation-circle me-2"></i>{title}
                            </h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            {typeof message === 'string' ? <p className="mb-0">{message}</p> : message}
                        </div>
                        <div className="modal-footer border-0">
                            {secondaryButtonText && (
                                <button type="button" className="btn btn-outline-secondary" onClick={onSecondary || onClose}>
                                    {secondaryButtonText}
                                </button>
                            )}
                            <button type="button" className="btn BtnBlack" onClick={handlePrimary}>
                                {primaryButtonText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
};

export default ErrorModal;